import { computed, defineComponent, onMounted, useContext, useCssModule, watch } from '@nuxtjs/composition-api';
import { useA11y, useModal } from '~/composables';
import { isLkEnabled } from '~/utils';
export default defineComponent({
    name: 'A11yBar',
    setup() {
        const a11y = useA11y();
        const context = useContext();
        const css = useCssModule();
        const modal = useModal();
        const viewport = context.$viewport;
        const shouldShowAdButton = computed(() => {
            return isLkEnabled(process.server ? context.ssrContext?.req?.headers.cookie : document.cookie);
        });
        function hideBar() {
            a11y.isBarVisible = false;
            setModesCSS();
        }
        function decreaseFontSize() {
            if (a11y.fontSize.increment <= a11y.fontSize.min) {
                a11y.fontSize.increment = a11y.fontSize.min;
            }
            else {
                a11y.fontSize.increment -= a11y.fontSize.step;
            }
            setFontSizeCSS();
        }
        function increaseFontSize() {
            if (a11y.fontSize.increment >= a11y.fontSize.max) {
                a11y.fontSize.increment = a11y.fontSize.max;
            }
            else {
                a11y.fontSize.increment += a11y.fontSize.step;
            }
            setFontSizeCSS();
        }
        function setFontSizeCSS() {
            document.documentElement.style.setProperty('--font-size-increment', `${a11y.fontSize.increment}px`);
        }
        function setModesCSS() {
            const enabledModes = Object.keys(a11y.modes).filter((mode) => !a11y.modes[mode].isEnabled);
            if (a11y.modes.images.isEnabled || a11y.modes.waterfall.isEnabled) {
                const textIndex = enabledModes.findIndex((mode) => mode === 'text');
                if (textIndex !== -1) {
                    enabledModes.splice(textIndex, 1);
                }
            }
            else if (a11y.modes.text.isEnabled) {
                enabledModes.push(a11y.modesCSSMap.text);
            }
            // Toggle special visible-bar mode
            if (a11y.isBarVisible) {
                enabledModes.push('visible-bar');
            }
            else {
                const barIndex = enabledModes.findIndex((mode) => mode === 'visible-bar');
                if (barIndex !== -1) {
                    enabledModes.splice(barIndex, 1);
                }
            }
            document.documentElement.dataset.a11y = enabledModes
                .map((mode) => a11y.modesCSSMap[mode] || mode)
                .join(' | ');
        }
        function toggleMode(modeKey) {
            a11y.modes[modeKey].isEnabled = !a11y.modes[modeKey].isEnabled;
            if (modeKey === 'text') {
                a11y.modes.images.isEnabled = !a11y.modes.text.isEnabled;
                a11y.modes.waterfall.isEnabled = !a11y.modes.text.isEnabled;
            }
            else if (['images', 'waterfall'].includes(modeKey)) {
                a11y.modes.text.isEnabled = !a11y.modes.images.isEnabled && !a11y.modes.waterfall.isEnabled;
            }
            setModesCSS();
        }
        onMounted(() => {
            setModesCSS();
            setFontSizeCSS();
            watch(() => a11y.isBarVisible, () => {
                if (a11y.isEnabled) {
                    setModesCSS();
                }
            });
            watch(() => viewport.breakpoint, () => {
                if (viewport.isLessThan('desktopMedium')) {
                    a11y.reset();
                }
            }, {
                immediate: true,
            });
        });
        return {
            a11y,
            css,
            hideBar,
            decreaseFontSize,
            increaseFontSize,
            modal,
            shouldShowAdButton,
            toggleMode,
        };
    },
});
